import React from 'react';
import classNames from 'classnames';

import { ExternalLink } from '../../../components';
import { FormattedMessage } from '../../../util/reactIntl';

import css from './AddressLinkMaybe.module.css';

const googleMapsSearchUrl = query =>
  `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(query)}`;

const getCoordinate = coordinate => {
  if (typeof coordinate !== 'number' && typeof coordinate !== 'string') {
    return null;
  }

  if (typeof coordinate === 'string' && coordinate.trim() === '') {
    return null;
  }

  const numericCoordinate = Number(coordinate);
  return Number.isFinite(numericCoordinate) ? numericCoordinate : null;
};

const getGoogleMapsHref = (address, geolocation) => {
  const lat = getCoordinate(geolocation?.lat);
  const lng = getCoordinate(geolocation?.lng);

  if (lat !== null && lng !== null && Math.abs(lat) <= 90 && Math.abs(lng) <= 180) {
    return googleMapsSearchUrl(`${lat},${lng}`);
  }

  return address ? googleMapsSearchUrl(address) : null;
};

// Functional component as a helper to build AddressLinkMaybe
const AddressLinkMaybe = props => {
  const { className, rootClassName, linkRootClassName, location, geolocation, publicData } = props;
  const { address, building } = location || publicData?.location || {};
  const addressText = typeof address === 'string' ? address.trim() : '';
  const buildingText = typeof building === 'string' ? building.trim() : '';
  const fullAddress = [buildingText, addressText].filter(Boolean).join(', ');
  const hrefToGoogleMaps = getGoogleMapsHref(addressText ? fullAddress : null, geolocation);

  const classes = classNames(rootClassName || css.address, className);
  return fullAddress || hrefToGoogleMaps ? (
    <p className={classes}>
      <span className={css.viewOnGoogleMapsWrapper}>
        {hrefToGoogleMaps ? (
          <ExternalLink className={linkRootClassName} href={hrefToGoogleMaps} target="_blank">
            {fullAddress ? <span>{fullAddress}</span> : null}
            <span className={css.mapAction}>
              <FormattedMessage id="AddressLinkMaybe.viewOnGoogleMaps" />
            </span>
          </ExternalLink>
        ) : (
          fullAddress
        )}
      </span>
    </p>
  ) : null;
};

export default AddressLinkMaybe;
